<template>
  <div class="el-form-item__content">
    <div class="keywords-filter-wrap" v-if="isKeyWordType">
      <keys-filter
          :keywords="keywords"
          :referencesNetworks="referencesNetworks"
          :loading="loading"
          @addKeyWord="addKeyWord"
          @enableKeyWord="enableKeyWord"
          @deleteKeyWord="deleteKeyWord"
          @choiceNetwork="choiceNetwork"
          @editKeyWord="editKeyWord"
      />
    </div>
    <el-divider v-if="isKeyWordType"></el-divider>

    <ul class="keywords-wrap" :class="userManageKeywords ? '' : disableClass">
      <li class="keywords-wrap__item">
        <keys :keywords="filters" @addKeyWord="addFilter" @deleteKeyWord="deleteFilter"/>
      </li>
      <li class="keywords-wrap__item">
        <stop-word :keywords="stopkeywords" @addStopWord="addStopWord" @deleteStopWord="deleteStopWord"/>
      </li>
    </ul>
    <div>
      <input type="file" @change="onFileChange" />
    </div>
    
  </div>
</template>

<script>
  // api
  import {
    getKeyWordsApi,
    getReferencesNetworksApi,
    getSettingsFiltersApi
  } from "../../../../../../api/feeds";

  // components
  import Keys from './components/Keys';
  import StopWord from './components/Stop';
  import KeysFilter from './components/KeysFilter';
  import {mapGetters} from 'vuex';
  import readXlsxFile from "read-excel-file";

  export default {
    name: "KeyWords",
    data() {
      return {
        keywords: [],
        stopkeywords: [],
        filters: [],
        referencesNetworks: [],
        type: 'keywords',
        disableClass: 'disabled',
        loading: false,
      };
    },
    computed: {
      ...mapGetters([
        'userManageKeywords',
      ]),
      feed() {
        return this.$store.getters['feed'](this.$route.params.threadId)
          ?
          this.$store.getters['feed'](this.$route.params.threadId)
          :
          [];
      },
      isKeyWordType() {
        return this.feed.threadtype === this.type;
      }
    },
    methods: {
      getData() {
        return {
          keywords: this.keywords,
          stopkeywords: this.stopkeywords,
          filters: this.filters
        };
      },
      deleteFilter(deleteIndex) {
        this.filters[deleteIndex].enabled = false;
      },
      addFilter() {
        this.filters.push({
          keyword: '',
          enabled: true,
        });
      },
      deleteKeyWord(deleteIndex) {
        let keywords = [];
        if (this.keywords.length > 1) {
          if (deleteIndex !== 0) {
            const before = this.keywords.slice(0, deleteIndex);
            const after = this.keywords.slice(deleteIndex + 1);
            keywords = [...before, ...after];
          } else {
            keywords = this.keywords.slice(1);
          }
        }
        this.keywords = [...keywords];
      },
      deleteStopWord(deleteIndex) {
        this.stopkeywords[deleteIndex].enabled = false;
      },
      addStopWord() {
        this.stopkeywords.push({
          keyword: '',
          enabled: true,
        });
      },
      addKeyWord() {
        this.keywords.push({
          keyword: '',
          enabled: true,
          networks: this.referencesNetworks.map(item => {
            return Number(item.id)
          })
        });
      },
      enableKeyWord({ index, enabled }) {
        this.keywords[index].enabled = enabled
      },
      editKeyWord({ index, keyword }) {
        this.keywords[index].keyword = keyword
      },
      choiceNetwork({ index, networks }) {
        this.keywords[index].networks = networks
      },
      getKeyWords() {
        let params = {
          thread_id: this.$route.params.threadId,
        };

        getReferencesNetworksApi().then(resp => {
          this.referencesNetworks = resp.data.filter(key => key.name != 'TikTok');
          let gs = resp.data.find(item => item.name == "GlobalSearch");
          gs.name = "СМИ"
          let vk = resp.data.find(item => item.name == "vk");
          vk.name = "VK"
          let dz = resp.data.find(item => item.name == "dz");
          dz.name = "DZ"
          let tw = resp.data.find(item => item.name == "tw");
          tw.name = "TW"
          let fb = resp.data.find(item => item.name == "Facebook");
          fb.name = "FB"
          let tg = resp.data.find(item => item.name == "Telegram");
          tg.name = "TG"
          let ig = resp.data.find(item => item.name == "Instagram");
          ig.name = "Inst"
          let yt = resp.data.find(item => item.name == "YouTube");
          yt.name = "YT"
          let ok = resp.data.find(item => item.name == "OK");
          ok.name = "OK"
        });

        getSettingsFiltersApi(params).then(resp => {
          this.filters = resp.data.filter
        });

        {
          this.loading = true;
          getKeyWordsApi(params).then(resp => {
            this.keywords = resp.data.keywords;
            this.stopkeywords = resp.data.stopkeywords;
            this.loading = false;
          });
        }
      },
      onFileChange(event) {
        let xlsxfile = event.target.files ? event.target.files[0] : null;
        readXlsxFile(xlsxfile, { sheet: 'Ключевые слова' }).then((rows) => {
          for (const item of rows.slice(1)) {
            if (!item[0]) {
              return
            }

            this.keywords.push({
              keyword: item[0],
              enabled: true,
              networks: this.referencesNetworks.map(item => {
                return Number(item.id)
              })
            });
          }
        })
        readXlsxFile(xlsxfile, { sheet: 'Стоп-слова' }).then((rows) => {
          for (const item of rows.slice(1)) {
            if (!item[0]) {
              return
            }

            this.stopkeywords.push({
              keyword: item[0],
              enabled: true,
            });
          }
        })
        readXlsxFile(xlsxfile, { sheet: 'Фильтры' }).then((rows) => {
          for (const item of rows.slice(1)) {
            if (!item[0]) {
              return
            }

            this.filters.push({
              keyword: item[0],
              enabled: true,
            });
          }
        })
      }
    },
    beforeMount() {
      this.getKeyWords();
    },
    components: {
      Keys,
      StopWord,
      KeysFilter,
    },
  };
</script>

<style>
  .keywords-wrap {
    padding: 0;
    margin: 0;
    list-style: none;
    display: flex;
  }
  .keywords-wrap.disabled {
    position: relative;
  }
  .keywords-wrap.disabled:before {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 5;
    background-color: rgba(255, 255, 255, 0.5);
  }
  .keywords-wrap__item {
    width: 50%;
  }
  @media screen and (max-width: 480px) {
    .keywords-wrap__item {
      width: 100%;
    }
    .keywords-wrap {
      display: block;
      }
  }
</style>
